export default "__VITE_ASSET__BE9pa_6N__"